/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument200,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument401,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument500,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationResponse,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentPathParams,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument.ts";
import { classModuleDisciplineConfigViewModelSchema } from "../classModuleDisciplineConfigViewModelSchema.ts";

export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentPathParamsSchema =
  z.object({
    classModuleId: z.coerce.number().int(),
    disciplineId: z.coerce.number().int(),
  }) as unknown as ToZod<PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument200Schema =
  z.lazy(
    () => classModuleDisciplineConfigViewModelSchema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument401Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument500Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument500>;

export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationResponseSchema =
  z.lazy(
    () =>
      patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocument200Schema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidShowOnStudentDocumentMutationResponse>;
